/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 图片列表头部组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-11 11:00:00
 */

import React from 'react'
import { PhotoItem } from '../../context/WatermarkBatchContext'
import FilterTabs, { FilterType } from './FilterTabs'
import FailedPhotosNotice from './FailedPhotosNotice'
import './ImageListHeader.scss'

interface ImageListHeaderProps {
  extractionFailedCount: number
  photosCount: number
  filterType: FilterType
  onFilterChange: (type: FilterType) => void
  allCount: number
  uneditedCount: number
  editedCount: number
  failedCount: number
  onViewFailedPhotos: () => void
  onTrack?: (params: {
    pageType: 'allPhoto' | 'notEdit' | 'edited' | 'failEdit'
    watermarkCnt?: number
    allPhotoCount?: number
    uneditedCount?: number
    editedCount?: number
    failedExtractionCount?: number
    photoNum?: number
    WatermarkID?: string
  }) => void
  watermarkCnt?: number
  allPhotoCount?: number
  failedExtractionCount?: number
  currentPhoto?: PhotoItem | null
}

const ImageListHeader: React.FC<ImageListHeaderProps> = ({
  extractionFailedCount,
  photosCount,
  filterType,
  onFilterChange,
  allCount,
  uneditedCount,
  editedCount,
  failedCount,
  onViewFailedPhotos,
  onTrack,
  watermarkCnt,
  allPhotoCount,
  failedExtractionCount,
  currentPhoto
}) => {
  return (
    <div className="headerContainer">
      <h3 className="title">选择照片</h3>

      <FailedPhotosNotice
        count={extractionFailedCount}
        onView={onViewFailedPhotos}
      />

      {photosCount > 0 && (
        <FilterTabs
          filterType={filterType}
          onFilterChange={onFilterChange}
          allCount={allCount}
          uneditedCount={uneditedCount}
          editedCount={editedCount}
          failedCount={failedCount}
          onTrack={onTrack}
          watermarkCnt={watermarkCnt}
          allPhotoCount={allPhotoCount}
          failedExtractionCount={failedExtractionCount}
          currentPhoto={currentPhoto}
        />
      )}
    </div>
  )
}

export default ImageListHeader
